<template>
  <div class="year section">
    <h1>Debug page</h1>
    <h2>Categories</h2>
    <button @click="getSingleDocCats">Get categories single file</button>
    {{ cats }}

    <button @click="catCategoriesCollection">Get categories collection</button>
    {{ catsCollection }}

    <button @click="copyToSingleFileCats">Copy to singleFileCats</button>

    <button @click="splitIncomeAndExpense">Split income and expense</button>

    <h2>Transactions</h2>
    <button @click="getSingleDocTransactions">
      Get transactions single file
    </button>
    {{ trans }}

    <button @click="catTransactionCollection">
      Get transaction collection
    </button>
    {{ transCollection }}

    <button @click="setSingleTransactions">
      set transactions to singlefile
    </button>

    <button @click="getAllTransactionsReferences">Export CSV</button>
    <label>Import CSV</label>
    <input type="file" @change="processCSV($event)" />
  </div>
</template>

<script>
import firebase from "firebase/app";



function csvJSON(csv) {
  var lines = csv.split("\n");

  var result = [];

  // NOTE: If your columns contain commas in their values, you'll need
  // to deal with those before doing the next step
  // (you might convert them to &&& or something, then covert them back later)
  // jsfiddle showing the issue https://jsfiddle.net/
  // var headers = lines[0].split(",");

  const headersCSV = ["date", "name", "category", "amount", "id"];

  // Ignore headers start from first line
  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(",");

    for (var j = 0; j < headersCSV.length; j++) {
      if (currentline[j]) {
        obj[headersCSV[j]] = currentline[j];
      }
    }

    if (obj.date) {
      result.push(obj);
    }
  }

  return result;
}

export default {
  data() {
    return {
      cats: [],
      catsCollection: [],
      transCollection: [],
      trans: [],
    };
  },
  created() {},

  methods: {
    getSingleDocCats() {
      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      const collectionRef = db.doc(`categories/${currentUser.uid}`);

      //TODO Implement this instead
      collectionRef.get().then((doc) => {
        this.cats = doc.data();
      });
    },
    catCategoriesCollection() {
      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      const collectionRef = db.collection(
        `users/${currentUser.uid}/categories`
      );
      collectionRef.get().then((collection) => {
        let test = [];
        collection.forEach((doc) => {
          test.push(doc.data());
          // commit("addCategory", doc.data());
        });
        this.catsCollection = test;
      });
    },
    copyToSingleFileCats() {
      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      const collectionRef = db.doc(`categories/${currentUser.uid}`);

      let singleFileCats = { categories: this.catsCollection };

      collectionRef.set(singleFileCats);
    },
    splitIncomeAndExpense() {
      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      const collectionRef = db.doc(`categories/${currentUser.uid}`);

      const income = this.cats.categories.filter((cat) => cat.income);
      const expense = this.cats.categories.filter((cat) => cat.expense);

      let singleFileCats = { income: income, expense: expense };

      collectionRef.set(singleFileCats);
    },
    getSingleDocTransactions() {
      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      const collectionRef = db.doc(
        `/transactions/${currentUser.uid}/2020-03/transactions`
      );

      collectionRef.get().then((doc) => {
        this.trans = doc.data();
      });
    },
    catTransactionCollection() {
      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      const collectionRef = db.collection(
        `users/${currentUser.uid}/transactions`
      );

      let date = new Date();
      const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      collectionRef
        .where("date", ">=", startOfMonth)
        .where("date", "<", endOfMonth)
        .get()
        .then((collection) => {
          let temp = [];
          collection.forEach((doc) => {
            const transaction = { id: doc.id, ...doc.data() };
            temp.push(transaction);
          });
          this.transCollection = temp;
        });
    },
    setSingleTransactions() {
      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      const collectionRef = db.doc(
        `/transactions/${currentUser.uid}/2020-03/transactions`
      );

      const income = this.transCollection
        .filter((transaction) => transaction.income)
        .map((transaction) => {
          delete transaction.income;
          return transaction;
        });
      const expense = this.transCollection
        .filter((transaction) => transaction.expense)
        .map((transaction) => {
          delete transaction.expense;
          return transaction;
        });
      let singleFileTransactions = { income: income, expense: expense };

      collectionRef.set(singleFileTransactions);
    },
    processCSV(event) {
      const file = event.target.files[0];
      var reader = new FileReader();

      var that = this;
      reader.onload = () => {
        const jsonImport = csvJSON(reader.result);
        that.importCSVToFirebase(jsonImport);
      };

      reader.readAsBinaryString(file);
    },
    importCSVToFirebase(jsonImport) {
      let transactionsReadyForImport = {};
      jsonImport.forEach((transaction) => {
        const dateString = this.getKeyMonth(new Date(transaction.date));
        if (!transactionsReadyForImport[dateString]) {
          transactionsReadyForImport[dateString] = [];
        }

        transactionsReadyForImport[dateString].push(transaction);
      });

      let readyImport = {};
      Object.keys(transactionsReadyForImport).forEach((key) => {
        let transactionsReadyForImportIncomeExpense = {
          income: [],
          expense: [],
        };

        const transactions = transactionsReadyForImport[key];
        transactions.forEach((transaction) => {
          transaction.amount = Number(transaction.amount);
          if (transaction.amount < 0) {
            transaction.amount = transaction.amount * -1;
            transactionsReadyForImportIncomeExpense.expense.push(transaction);
          } else {
            transactionsReadyForImportIncomeExpense.income.push(transaction);
          }
        });
        readyImport[key] = transactionsReadyForImportIncomeExpense;
      });

      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      Object.keys(readyImport).forEach((key) => {
        const docRef = db.doc(
          `/transactions/${currentUser.uid}/${key}/transactions`
        );

        firebase.firestore().runTransaction((transaction) => {
          // Gets document and if not exist create
          // If exists update
          return transaction
            .get(docRef)
            .then((doc) => {
              if (!doc.exists) {
                docRef.set(readyImport[key]);
              } else {
                transaction.update(
                  docRef,
                  readyImport[key]
                );
              }
            });
        });
      });
    },
    getKeyMonth(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      if (month < 10) {
        return `${year}-0${month}`;
      } else {
        return `${year}-${month}`;
      }
    },
  },
};
</script>
